<template>
    <div>
        <main class="container">
            <div class="row">
                <div class="col-md-3">
                    <filters-panel ref="filtersPanel" @change="onChangeFilters"></filters-panel>
                </div>

                <div class="col-md-9">
                    <div class="row no-results" v-if="!loading && layersFiltered.length === 0">
                        <div class="col-md-12 align-self-center">
                            <i class="fas fa-search"></i>
                            <h3>{{ $t('no_resultados') }}</h3>
                        </div>
                    </div>

                    <div class="row" v-if="!loading && layersFiltered.length > 0" style="margin-bottom: 20px">
                        <div class="col-md-12">
                            <h2>{{ layersFiltered.length }} {{ $t('capas_encontradas') }}</h2>
                        </div>
                    </div>

                    <div class="row mb-2" v-if="!loading && layersFiltered.length > 0">
                        <!--<transition-group name="fade-list" tag="div">-->
                        <div class="col-md-12"
                             v-for="layer in layersPaged"
                             v-if="layer.is_published == 1"
                             :key="layer.id">
                            <LayerItem :layer="layer"></LayerItem>
                        </div>
                        <!--</transition-group>-->

                        <div class="col-md-12 align-items-center">
                            <nav v-if="totalPages > 1">
                                <paginator :total-pages="totalPages" :current-page.sync="currentPage"></paginator>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>
        </main>
    </div>

</template>

<script>
    import LayerItem from "./LayerItem";
    import {LayersService} from "../../../commons/services/layersService";
    import Paginator from "../../components/Paginator";
    import FiltersPanel from "../../components/FiltersPanel";
    import {FiltersLayerUtils} from "../../../commons/utils/filtersLayerUtils";
    import {ArrayUtils} from "../../../commons/utils/arrayUtils";

    export default {
        name: 'CatalogApp',
        components: {FiltersPanel, Paginator, LayerItem},
        props: {},
        data: () => ({
            loading: true,
            layers: [],
            currentPage: 1,
            itemsPerPage: 6,
            totalPages: 0,
            filters: {}
        }),
        computed: {
            locale() {
                return this.$i18n.locale
            },
            languages() {
                return [
                    {title: this.$t("message.valenciano"), key: 'ca'},
                    {title: this.$t("message.castellano"), key: 'es'}
                ];
            },
            language() {
                let currentLanguage = null;

                this.languages.some(item => {
                    if (item.key === this.$i18n.locale) {
                        currentLanguage = item;
                        return true;
                    }
                });

                return currentLanguage
            },
            layersFiltered() {
                this.currentPage = 1;

                let filteredLayersByGroup = this.layers.filter((layer) => {
                    return layer.is_published == 1;
                });

                if (this.filters.groupsSelected && this.filters.groupsSelected.length > 0) {
                    filteredLayersByGroup = FiltersLayerUtils.filterLayersByGroupsIds(this.filters.groupsSelected, filteredLayersByGroup, this.$refs.filtersPanel.groups);
                }

                if (!this.filters.searchText) return filteredLayersByGroup;

                return FiltersLayerUtils.filterLayersByText(this.filters.searchText, filteredLayersByGroup, this.locale);

            },
            layersPaged() {
                this.totalPages = Math.ceil(this.layersFiltered.length / this.itemsPerPage);

                if (this.totalPages === 1) return this.layersFiltered;

                const start = (this.currentPage - 1) * this.itemsPerPage;
                let end = this.itemsPerPage * this.currentPage;
                if (end > this.layersFiltered.length) end = this.layersFiltered.length;

                return this.layersFiltered.slice(start, end);
            }
        },
        mounted() {
            this.loadLayers();
        },
        methods: {
            async loadLayers() {
                this.loading = true;
                try {
                    this.layers = await LayersService.fetchLayers();
                    this.layers = ArrayUtils.orderByKey(this.layers, `title_${this.locale}`);
                    this.loading = false;
                } catch (e) {
                    console.error('Error cargando las capas...');
                    this.loading = false;
                }
            },
            changeLocale(value) {
                this.$i18n.locale = value
            },
            onChangeFilters(value) {
                this.filters = value;
            },

        }
    }
</script>

<style lang="scss" scoped>
    .container {
        padding-top: 5rem;
    }

    .navbar-dark .navbar-nav .nav-link {
        color: white;
    }

    .no-results {
        text-align: center;
        min-height: 300px;
        color: darkgray;

        i {
            font-size: 3rem;
            margin-bottom: 10px;
        }
    }
</style>